import React, { useState } from 'react';
import { SendIcon, CheckCircle2Icon } from 'lucide-react';
export function ContactForm() {
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };
  return <section id="contact" className="py-24 bg-white" data-id="element-1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-3">
          <div data-id="element-4">
            <h2 className="text-3xl font-bold text-slate-900 mb-6" data-id="element-5">
              Have a Question Before Launch?
            </h2>
            <p className="text-slate-600 text-lg mb-8 leading-relaxed" data-id="element-6">
              For business owners, partners, or service providers interested in
              learning more before the anticipated August 1, 2026 launch, please
              send a message and we will follow up as soon as possible.
            </p>

            <div className="space-y-6" data-id="element-7">
              <div className="flex items-center gap-4" data-id="element-8">
                <div className="w-10 h-10 bg-slate-100 rounded-full flex items-center justify-center" data-id="element-9">
                  <CheckCircle2Icon className="w-5 h-5 text-blue-600" data-id="element-10" />
                </div>
                <span className="text-slate-700 font-medium" data-id="element-11">
                  Direct support for SMBs
                </span>
              </div>
              <div className="flex items-center gap-4" data-id="element-12">
                <div className="w-10 h-10 bg-slate-100 rounded-full flex items-center justify-center" data-id="element-13">
                  <CheckCircle2Icon className="w-5 h-5 text-blue-600" data-id="element-14" />
                </div>
                <span className="text-slate-700 font-medium" data-id="element-15">
                  Partnership opportunities
                </span>
              </div>
              <div className="flex items-center gap-4" data-id="element-16">
                <div className="w-10 h-10 bg-slate-100 rounded-full flex items-center justify-center" data-id="element-17">
                  <CheckCircle2Icon className="w-5 h-5 text-blue-600" data-id="element-18" />
                </div>
                <span className="text-slate-700 font-medium" data-id="element-19">
                  Custom solution inquiries
                </span>
              </div>
            </div>
          </div>

          <div className="bg-slate-50 p-8 md:p-10 rounded-3xl border border-slate-100" data-id="element-20">
            {submitted ? <div className="text-center py-10" data-id="element-21">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-22">
                  <CheckCircle2Icon className="w-8 h-8 text-green-600" data-id="element-23" />
                </div>
                <h3 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-24">
                  Message Sent!
                </h3>
                <p className="text-slate-600" data-id="element-25">We'll get back to you shortly.</p>
                <button onClick={() => setSubmitted(false)} className="mt-6 text-blue-600 font-semibold" data-id="element-26">
                  Send another message
                </button>
              </div> : <form onSubmit={handleSubmit} className="space-y-4" data-id="element-27">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-28">
                  <div className="space-y-1.5" data-id="element-29">
                    <label className="text-xs font-bold text-slate-500 uppercase tracking-wider" data-id="element-30">
                      Name
                    </label>
                    <input required type="text" className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:ring-2 focus:ring-blue-500 outline-none" placeholder="Your Name" data-id="element-31" />
                  </div>
                  <div className="space-y-1.5" data-id="element-32">
                    <label className="text-xs font-bold text-slate-500 uppercase tracking-wider" data-id="element-33">
                      Email
                    </label>
                    <input required type="email" className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:ring-2 focus:ring-blue-500 outline-none" placeholder="Email Address" data-id="element-34" />
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-35">
                  <div className="space-y-1.5" data-id="element-36">
                    <label className="text-xs font-bold text-slate-500 uppercase tracking-wider" data-id="element-37">
                      Phone
                    </label>
                    <input type="tel" className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:ring-2 focus:ring-blue-500 outline-none" placeholder="Phone Number" data-id="element-38" />
                  </div>
                  <div className="space-y-1.5" data-id="element-39">
                    <label className="text-xs font-bold text-slate-500 uppercase tracking-wider" data-id="element-40">
                      Business Name
                    </label>
                    <input type="text" className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:ring-2 focus:ring-blue-500 outline-none" placeholder="Company Name" data-id="element-41" />
                  </div>
                </div>
                <div className="space-y-1.5" data-id="element-42">
                  <label className="text-xs font-bold text-slate-500 uppercase tracking-wider" data-id="element-43">
                    Question / Message
                  </label>
                  <textarea required className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:ring-2 focus:ring-blue-500 outline-none h-32" placeholder="How can we help you?" data-id="element-44"></textarea>
                </div>
                <button type="submit" className="w-full py-4 bg-slate-900 text-white font-bold rounded-xl hover:bg-slate-800 transition-all flex items-center justify-center gap-2" data-id="element-45">
                  Send Message
                  <SendIcon className="w-5 h-5" data-id="element-46" />
                </button>
              </form>}
          </div>
        </div>
      </div>
    </section>;
}